import React, { useEffect, useRef, useState } from 'react'

import VipLists from './vipLists'
import { useTranslation } from 'react-i18next'
import Tabs from '@/wmCompoments/tabs'
import TabsButton from '@/wmCompoments/tabs/TabsButton'
import { Swiper, SwiperSlide } from 'swiper/react'
import styles from '../styles/vipRebateRate.module.scss'


const VipRebateRate = ({rebate}) => {
  const { t } = useTranslation('vip')
  const rebateRaeTabs = rebate?.[0].list

  const swiperRef = useRef<any>(null)
  const [activeIndex, setActiveIndex] = useState(0)
  
  
  return (
    <div className={styles.vipRebateRate}>
      <div className={styles.rebateRate_title}>
        <div>Cashback ratio</div>
        <div>{t('vipRebateRate')}</div>
      </div>

      <div className={styles.rebateRate_item}>
        <Tabs type={'line'}
          onClickTab={(key: any) => {
            setActiveIndex(key)
            swiperRef.current?.swiper?.slideToLoop(key)
          }}
          activeTab={activeIndex?.toString()}
        >
          {
            rebateRaeTabs?.map((v, index) => {
              return <TabsButton key={index} className={styles.item}>
                {v.venueName}
              </TabsButton>
          })
          }
        </Tabs>

        <div className={styles.vipSwiper}>
          <Swiper
            ref={swiperRef}
            initialSlide={activeIndex}  // 初始页
            direction='horizontal' // 水平滑动方向
            loop
            onSlideChange={(swiper) => {
              setActiveIndex(swiper.realIndex)
            }}
          >
            {rebateRaeTabs?.map((v,index)=>{
              return <SwiperSlide key={index}>
                <VipLists 
                  list={rebateRaeTabs}
                  onTitle = {function (v:any,index3:number){
                    if (index3 === index) {
                      return <div key={index3}>{v.venueName}</div>;
                    }
                    return null;
                  }}
                  onValue={function (e: any, x: any, index1, index2) {
                    if (index2 === index) {
                      return <div key={index2}>{rebate?.[index1].list?.[index2].maxRate}</div>;
                    }
                    return null;
                  }}
                />
              </SwiperSlide>
            })}
          </Swiper>
        </div>
      </div>
    </div>  
  )
}

export default VipRebateRate
